import { CardActionDetails } from '../../../utils/cardActions';
import locales from './locales';

export const ACTIVATE: CardActionDetails = {
  ...locales.activate,
  iconName: 'card-recto',
  operationId: 'activate',
};

export const DELETE: CardActionDetails = {
  ...locales.delete,
  iconName: 'trash',
  isDanger: true,
  operationId: 'deactivate-confirm',
};

export const LOCK: CardActionDetails = {
  ...locales.lock,
  iconName: 'lock',
  operationId: 'lock-confirm',
};

export const LOCK_OPTIONS: CardActionDetails = {
  ...locales.lockOptions,
  iconName: 'lock',
  operationId: 'lock',
};

export const MARK_AS_LOST: CardActionDetails = {
  ...locales.markAsLost,
  iconName: 'lock',
  isDanger: true,
  operationId: 'lost-confirm',
};

export const MARK_AS_STOLEN: CardActionDetails = {
  ...locales.markAsStolen,
  iconName: 'lock',
  isDanger: true,
  operationId: 'stolen-confirm',
};

export const ORDER_NEW_PHYSICAL_CARD: CardActionDetails = {
  ...locales.orderNewPhysicalCard,
  iconName: 'card-recto',
  operationId: 'order-new-physical',
};

export const REQUEST_NEW_PHYSICAL_CARD: CardActionDetails = {
  ...locales.requestNewPhysicalCard,
  iconName: 'card-recto',
  operationId: 'request-new-physical',
};

export const UNBLOCK_PIN: CardActionDetails = {
  ...locales.unblockPin,
  iconName: 'unlock',
  operationId: 'unblock-pin',
};

export const UNLOCK: CardActionDetails = {
  ...locales.unlock,
  iconName: 'unlock',
  operationId: 'unlock-confirm',
};

export const UPDATE_PIN: CardActionDetails = {
  ...locales.updatePin,
  iconName: 'switch',
  operationId: 'update-pin',
};
